// React
import React from "react";

type ControllerPropsTypes = {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
};

function Controller(props: ControllerPropsTypes) {
  return (
    <div className='flex row align-items-center' style={{ gap: 32 }}>
      {props.value === 0 ? (
        <div className='control-btn small-btn' style={{ cursor: "default" }}>
          <img src={`/assets/images/menu/minus.svg`} alt={"minuse button"} />
        </div>
      ) : (
        <div className='control-btn small-btn'>
          <img
            src={`/assets/images/menu/minus2.svg`}
            alt={"minuse button"}
            onClick={() => {
              props.setValue(props.value - 1);
            }}
          />
        </div>
      )}
      <div className='control-count TO-title-1'>{props.value}</div>
      <div
        className='control-btn small-btn'
        onClick={() => {
          props.setValue(props.value + 1);
        }}
      >
        <img src={`/assets/images/menu/plus.svg`} alt={"plus button"} />
      </div>
    </div>
  );
}
export default Controller;
